import ReactMap from "../../../shared/map/map";
import {OverlayView, OverlayViewF} from "@react-google-maps/api";
import car from "../../../assets/images/car-icon.svg"
const LiveTrackMap = ({vehiclePos}) => {

    return (
        <ReactMap>
            {vehiclePos &&
                <OverlayViewF
                    position={vehiclePos}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <div className={'icon width-35'}>
                        <img src={car}/>
                    </div>
                </OverlayViewF>
            }

        </ReactMap>
    )
}

export default LiveTrackMap;
